import classNames from "classnames";
import type { ReactNode } from "react";
import type { DefaultValues } from "react-hook-form";
import { Button, FormProvider, FormTag, flexStyles } from "ui";
import type { ZodSchema } from "zod";

interface Props<T> {
  schema: ZodSchema<T>;
  defaultValues: DefaultValues<T>;
  onSubmit: (data: T) => void | Promise<void>;
  onClose: () => void;
  children: ReactNode;
  submitLabel?: string;
}

export function BlockEditorForm<T extends object>({
  schema,
  defaultValues,
  onSubmit,
  onClose,
  children,
  submitLabel = "Update",
}: Props<T>) {
  const handleSubmit = async (data: T) => {
    await onSubmit(data);
    onClose();
  };

  return (
    <FormProvider zod schema={schema} defaultValues={defaultValues}>
      <FormTag onSubmit={handleSubmit}>
        {children}

        <div className={classNames(flexStyles.horiz050, flexStyles.justifyEnd)}>
          <Button onClick={onClose} type="secondary" size="small">
            Cancel
          </Button>
          <Button htmlButtonType="submit" size="small">
            {submitLabel}
          </Button>
        </div>
      </FormTag>
    </FormProvider>
  );
}
